import { useGLTF } from '@react-three/drei'
import React, { useRef } from 'react'
import { useMediaQuery } from 'react-responsive';

export default function Shoe(props) {
  const { scene } = useGLTF('/vincentshoes.glb') // Load the model
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  // Correct model orientation and recenter its pivot point
  if (scene) {
    scene.rotation.set(-Math.PI / 2 + 0.15, 0.05, 0.05) // Rotate upright
    const scale = isMobile ? 0.03 : 0.05; // Scale down the model on mobile
    scene.scale.set(scale, scale, scale); // Scale down the model
  }

  return <primitive object={scene} {...props} />
}